import { useQuery } from '@apollo/client';

import type { CompanyArticlesQueryVariables } from '../../graphql/queries/companies-articles.gql-types';
import { CompanyArticlesDocument } from '../../graphql/queries/companies-articles.gql-types';

export const useCompaniesArticles = ({ limit = 3, offset = 0 } = {}) => {
  const variables: CompanyArticlesQueryVariables = {
    limit,
    offset,
  };

  const response = useQuery(CompanyArticlesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
